import { and } from "truth-helpers";
import DInlineFloat from "float-kit/components/d-inline-float";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
import templateOnly from "@ember/component/template-only";
const DHeadlessTooltip = setComponentTemplate(precompileTemplate("\n  <DInlineFloat @instance={{@tooltip}} @trapTab={{and @tooltip.options.interactive @tooltip.options.trapTab}} @mainClass=\"fk-d-tooltip__content\" @innerClass=\"fk-d-tooltip__inner-content\" @role=\"tooltip\" @inline={{@inline}} />\n", {
  strictMode: true,
  scope: () => ({
    DInlineFloat,
    and
  })
}), templateOnly(undefined, "d-headless-tooltip:DHeadlessTooltip"));
export default DHeadlessTooltip;